import { render, staticRenderFns } from "./CrmHistory.vue?vue&type=template&id=ebcb5f52&scoped=true"
import script from "./CrmHistory.vue?vue&type=script&lang=ts"
export * from "./CrmHistory.vue?vue&type=script&lang=ts"
import style0 from "./CrmHistory.vue?vue&type=style&index=0&id=ebcb5f52&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebcb5f52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebcb5f52')) {
      api.createRecord('ebcb5f52', component.options)
    } else {
      api.reload('ebcb5f52', component.options)
    }
    module.hot.accept("./CrmHistory.vue?vue&type=template&id=ebcb5f52&scoped=true", function () {
      api.rerender('ebcb5f52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crm/CrmHistory.vue"
export default component.exports